import { render } from "./BranchItem.vue?vue&type=template&id=09b89e44&scoped=true"
import script from "./BranchItem.vue?vue&type=script&lang=js"
export * from "./BranchItem.vue?vue&type=script&lang=js"

import "./BranchItem.vue?vue&type=style&index=0&id=09b89e44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b89e44"]])

export default __exports__